(function () {
    'use strict';

    // Client-side only. Every org, union and sector is already in the DOM by the time
    // the page renders, so filtering needs no request — and stays instant on mobile,
    // which is 68% of traffic.
    document.addEventListener('DOMContentLoaded', function () {
        const input = document.getElementById('site-search');
        if (!input) return;

        const clearBtn = document.getElementById('site-search-clear');
        const targets = Array.prototype.slice.call(document.querySelectorAll('[data-search]'));
        if (!targets.length) return;

        // Cache the haystack once rather than reading the attribute on every keystroke.
        const items = targets.map(function (el) {
            return {
                el: el,
                text: (el.getAttribute('data-search') || '').toLowerCase(),
                // Panels are hidden wholesale when none of their items match, so an
                // empty "Industrial Action by Union" card doesn't sit there confusingly.
                panel: el.closest('[data-search-panel]')
            };
        });

        const panels = Array.prototype.slice.call(document.querySelectorAll('[data-search-panel]'));
        const emptyEls = Array.prototype.slice.call(document.querySelectorAll('[data-search-empty]'));

        function apply(rawTerm) {
            const term = rawTerm.trim().toLowerCase();
            const matchedPanels = new Set();
            let total = 0;

            items.forEach(function (item) {
                const hit = term === '' || item.text.indexOf(term) !== -1;
                item.el.classList.toggle('d-none', !hit);
                if (hit) {
                    total++;
                    if (item.panel) matchedPanels.add(item.panel);
                }
            });

            panels.forEach(function (panel) {
                panel.classList.toggle('d-none', term !== '' && !matchedPanels.has(panel));
            });

            emptyEls.forEach(function (el) {
                el.classList.toggle('d-none', total > 0);
            });

            if (clearBtn) clearBtn.classList.toggle('d-none', term === '');
        }

        let timer = null;
        input.addEventListener('input', function () {
            window.clearTimeout(timer);
            timer = window.setTimeout(function () { apply(input.value); }, 120);
        });

        input.addEventListener('keydown', function (evt) {
            if (evt.key === 'Escape') {
                input.value = '';
                apply('');
            }
        });

        if (clearBtn) {
            clearBtn.addEventListener('click', function () {
                input.value = '';
                apply('');
                input.focus();
            });
        }

        // Respect a term restored by the browser on back-navigation.
        if (input.value) apply(input.value);
    });
})();
